import { jsx as _jsx } from "react/jsx-runtime";
import { InlineError } from './inlineError.js';
import { Tooltip } from './components/index.js';
import { MyST } from './MyST.js';
export const InlineExpression = ({ node }) => {
    var _a, _b, _c;
    if (!node.result) {
        return _jsx(InlineError, { value: `Unexecuted inline expression for: ${node.value}` });
    }
    if (((_a = node.result) === null || _a === void 0 ? void 0 : _a.status) !== 'ok') {
        return _jsx(InlineError, { value: `${(_b = node.result) === null || _b === void 0 ? void 0 : _b.ename}: ${(_c = node.result) === null || _c === void 0 ? void 0 : _c.evalue}` });
    }
    // TODO: something with Thebe in the future!
    return (_jsx(Tooltip, { title: _jsx("code", { children: node.value }), children: _jsx("span", { className: "border-b border-dotted cursor-help", children: _jsx(MyST, { ast: node.children }) }) }));
};
const INLINE_EXPRESSION_RENDERERS = {
    inlineExpression: InlineExpression,
};
export default INLINE_EXPRESSION_RENDERERS;
